<st-view-state>
    <div class="st-live-view-state-header">
        <st-text-area-overlay
            class="st-live-view-state-header__title"
            minHeight="2rem"
            panelClass="st-live-view-state-header__title"
            [value]="viewStateTitle$ | ngrxPush"
            [placeholder]="languageSettings.PSTWebAddViewTitleLabel"
            [required]="true"
            (changed)="updateTitle($event)" />
    </div>
    <mat-tab-group class="st-playbook-view-state-tab-group">
        <mat-tab [label]="languageSettings.PSTWebSettingsBar">
            <div class="st-live-view-state-tab-settings">
                <ng-container>
                    <div
                        *ngrxLet="viewStateLayout$ as viewStateLayout"
                        class="st-live-view-state-tab-settings-default-layout">
                        <span class="st-live-view-state-tab-settings-default-layout__label"> {{ languageSettings.PSTWebDefLayoutLabel }} </span>
                        <button
                            class="st-live-view-state-tab-settings-default-layout__button"
                            mat-stroked-button
                            [matMenuTriggerFor]="layoutMenu">
                            {{ viewStateLayout?.Label }} {{ languageSettings.PSTWebLayoutLabel }}
                        </button>
                        <mat-menu #layoutMenu="matMenu">
                            <mat-selection-list
                                hideSingleSelectionIndicator
                                [multiple]="false"
                                (selectionChange)="updateLayout(viewStateLayout, $event?.options?.[0]?.value)">
                                <mat-list-option
                                    *ngFor="let option of viewStateLayout?.Options"
                                    [value]="option.id">
                                    <div
                                        matListItemTitle
                                        [dir]="isRTL">
                                        {{ option.title }}
                                    </div>
                                </mat-list-option>
                            </mat-selection-list>
                        </mat-menu>
                    </div>
                </ng-container>
                <div
                    *ngrxLet="viewStateGrouping$ as viewStateGrouping"
                    class="st-live-view-state-tab-settings-default-grouping">
                    <span class="st-live-view-state-tab-settings-default-grouping__label"> {{ languageSettings.PSTWebDefContGroupByCriteriaLabel }}</span>
                    <button
                        class="st-live-view-state-tab-settings-default-grouping__button"
                        mat-stroked-button
                        [matMenuTriggerFor]="groupingMenu">
                        {{ viewStateGrouping?.Label }}
                    </button>
                    <mat-menu #groupingMenu="matMenu">
                        <mat-selection-list
                            hideSingleSelectionIndicator
                            [multiple]="false"
                            (selectionChange)="updateGroupBy(viewStateGrouping, $event?.options?.[0]?.value)">
                            <mat-list-option
                                *ngFor="let option of viewStateGrouping?.Options"
                                [value]="option.id"
                                [dir]="isRTL">
                                <div matListItemTitle>{{ option.title }}</div>
                            </mat-list-option>
                        </mat-selection-list>
                    </mat-menu>
                </div>
                <div class="st-live-view-state-tab-settings-default-grouping-order">
                    <span class="st-live-view-state-tab-settings-default-grouping-order__label"> {{ languageSettings.PSTWebGroupSortOrderLabel }} </span>
                    <button
                        mat-icon-button
                        (click)="toggleGroupSortOrder()">
                        <mat-icon> {{ viewStateGroupByIcon$ | ngrxPush }} </mat-icon>
                    </button>
                </div>
                <div
                    *ngrxLet="viewStateSorting$ as viewStateSorting"
                    class="st-live-view-state-tab-settings-default-sorting">
                    <span class="st-live-view-state-tab-settings-default-sorting__label"> {{ languageSettings.PSTWebDefContSortByCriteriaLabel }}</span>
                    <button
                        mat-stroked-button
                        class="st-live-view-state-tab-settings-default-sorting__button"
                        [matMenuTriggerFor]="sortingMenu">
                        {{ viewStateSorting?.Label }}
                    </button>
                    <mat-menu #sortingMenu="matMenu">
                        <mat-selection-list
                            hideSingleSelectionIndicator
                            [multiple]="false"
                            (selectionChange)="updateSortBy(viewStateSorting, $event?.options?.[0]?.value)">
                            <mat-list-option
                                *ngFor="let option of viewStateSorting?.AllOptions"
                                [value]="option.id"
                                [dir]="isRTL">
                                <div matListItemTitle>{{ option.title }}</div>
                            </mat-list-option>
                        </mat-selection-list>
                    </mat-menu>
                </div>
                <div class="st-live-view-state-tab-settings-default-sorting-order">
                    <span class="st-live-view-state-tab-settings-default-grouping-order__label">{{ languageSettings.PSTWebContentSortOrder }} </span>
                    <button
                        mat-icon-button
                        (click)="toggleSortOrder()">
                        <mat-icon> {{ viewStateSortByIcon$ | ngrxPush }} </mat-icon>
                    </button>
                </div>
            </div>
        </mat-tab>
        <mat-tab [label]="languageSettings.PSTWebFilterRequiredLabel">
            <div class="st-live-view-state-tab-required">
                <div
                    *ngIf="viewStateHasRequiredFilters$ | ngrxPush; else hasNoFilters"
                    class="st-live-view-state-tab-required-missing">
                    <div class="st-live-view-state-tab-required-filter-buttons">
                        <button
                            mat-stroked-button
                            color="primary"
                            class="st-live-view-state-tab-required-filter-buttons__add"
                            [matMenuTriggerFor]="listRequiredFilterDropDownMenu">
                            {{ '+ ' + languageSettings.PSTWebAddFilterLabel }}
                        </button>
                        <button
                            mat-flat-button
                            class="st-live-view-state-tab-required-filter-buttons__clear-all"
                            (click)="onClearAllFilters(true)">
                            {{ languageSettings.PSTWebClearAllLabel }}
                        </button>
                    </div>
                    <st-filter-list
                        [disabled]="false"
                        [filters]="viewStateRequiredFilters$ | ngrxPush"
                        [filterType]="filterTypes.REQUIRED"
                        (remove)="onRemoveFilter($event, filterTypes.REQUIRED)" />
                </div>
                <ng-template #hasNoFilters>
                    <div class="st-live-view-state-tab-required-missing__label">There are no required filters configured currently for this view.</div>
                    <button
                        mat-stroked-button
                        color="primary"
                        class="st-live-view-state-tab-required-missing__add"
                        [matMenuTriggerFor]="listRequiredFilterDropDownMenu">
                        {{ '+ ' + languageSettings.PSTWebAddFilterLabel }}
                    </button>
                </ng-template>
                <mat-menu #listRequiredFilterDropDownMenu="matMenu">
                    <mat-selection-list
                        st-click-stop-propagation
                        [ngModel]="viewStateRequiredFiltersIDs$ | ngrxPush"
                        (selectionChange)="onFilterStateChange($event, true)">
                        @for (item of viewStateAllFilters$ | ngrxPush; track item.ID) {
                            <mat-list-option
                                [disabled]="!item.NotUsed && !item.IsRequired"
                                [dir]="isRTL"
                                [value]="item.ID">
                                {{ item.DefaultCaption }}
                            </mat-list-option>
                        }
                    </mat-selection-list>
                </mat-menu>
            </div>
        </mat-tab>
        <mat-tab [label]="languageSettings.PSTWebOptionalFiltersLabel">
            <div class="st-live-view-state-tab-optional">
                <div
                    *ngIf="viewStateHasOptionalFilters$ | ngrxPush; else hasNoOptionalFilters"
                    class="st-live-view-state-tab-optional-missing">
                    <div class="st-live-view-state-tab-optional-filter-buttons">
                        <button
                            mat-stroked-button
                            color="primary"
                            class="st-live-view-state-tab-optional-filter-buttons__add"
                            [matMenuTriggerFor]="listOptionalFilterDropDownMenu">
                            {{ '+ ' + languageSettings.PSTWebAddFilterLabel }}
                        </button>

                        <button
                            mat-flat-button
                            class="st-live-view-state-tab-optional-filter-buttons__clear-all"
                            (click)="onClearAllFilters(false)">
                            {{ languageSettings.PSTWebClearAllLabel }}
                        </button>
                    </div>
                    <st-filter-list
                        [disabled]="false"
                        [filters]="viewStateOptionalFilters$ | ngrxPush"
                        [filterType]="filterTypes.OPTIONAL"
                        (remove)="onRemoveFilter($event, filterTypes.OPTIONAL)" />
                </div>
                <ng-template #hasNoOptionalFilters>
                    <div class="st-live-view-state-tab-optional-missing__label">There are no optional filters configured currently for this view.</div>
                    <button
                        mat-stroked-button
                        color="primary"
                        class="st-live-view-state-tab-optional-missing__add"
                        [matMenuTriggerFor]="listOptionalFilterDropDownMenu">
                        {{ '+ ' + languageSettings.PSTWebAddFilterLabel }}
                    </button>
                </ng-template>
                <mat-menu #listOptionalFilterDropDownMenu="matMenu">
                    <mat-selection-list
                        st-click-stop-propagation
                        [ngModel]="viewStateOptionalFiltersIDs$ | ngrxPush"
                        (selectionChange)="onFilterStateChange($event, false)">
                        @for (item of viewStateAllFilters$ | ngrxPush; track item.ID) {
                            <mat-list-option
                                [disabled]="!item.NotUsed && item.IsRequired"
                                [dir]="isRTL"
                                [value]="item.ID">
                                {{ item.DefaultCaption }}
                            </mat-list-option>
                        }
                    </mat-selection-list>
                </mat-menu>
            </div>
        </mat-tab>
    </mat-tab-group>
</st-view-state>
